import React, { Component } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';

import { CustomerList, ProductList } from '@C/CreditCustomers/_utils/';
import services from '@C/CreditCustomers/_utils/data';
import { formatCurrency, TableGrid } from '@C/TableGrid';
import { ShiftsList, StaffList } from '@C/Utils';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';
import { authHeader } from '@H';

const col = [
  {
    name: 'Date',
    key: 'time_stamp',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Slip #',
    key: 'slip_no',
  },
  {
    name: 'Customer',
    key: 'credit_customer',
    formatter(props) {
      return <>{props.name}</>;
    },
  },
  {
    name: 'Vehicle',
    key: 'vehicle.vehicle_no',
  },
  {
    name: 'Product',
    key: 'product',
    formatter(props) {
      return <>{props?.name || 'Cash Given'}</>;
    },
  },
  {
    name: 'Rate',
    key: 'product',
    formatter(props) {
      return <>{props?.price || '--'}</>;
    },
  },
  {
    name: 'Qty',
    key: 'quantity',
  },
  {
    name: 'Amount',
    key: 'all',
    formatter(props) {
      return (
        <>
          {formatCurrency(
            props?.after_discount + props.discount - props.cash_given || 0,
          ) || '--'}
        </>
      );
    },
  },
  {
    name: 'Discount',
    key: 'discount',
    type: 'currency',
  },
  {
    name: 'Amount (Excl Tax)',
    key: 'all',
    formatter(props) {
      return (
        <>
          {formatCurrency(props?.after_discount - props.cash_given || 0) ||
            '--'}
        </>
      );
    },
  },
  {
    name: 'Cash given',
    key: 'cash_given',
    type: 'currency',
  },
  {
    name: 'Amount (Inc Tax)',
    key: 'after_tax',
    type: 'currency',
  },
  {
    name: 'Staff',
    key: 'cashier',
    formatter(props) {
      return (
        <>
          {props.first_name} {props.last_name}
        </>
      );
    },
  },
  {
    name: 'Notes',
    key: 'notes',
  },
];

const enabledActions = [
  {
    action: 'Delete',
    roles: ['Manager', 'Dealer'],
  },
];

export default class SlipList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slipList: [],
      selectedId: '',
      showModal: false,
      staff_id: this.props.cod ? this.props.staff : '',
      cashier_duty_id: this.props.cod ? this.props.duty : '',
      start_date: this.props.cod
        ? this.props.date
        : dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: this.props.cod ? this.props.date : dayjs().format('YYYY-MM-DD'),
      product_id: '',
      shift_id: '',
      credit_customer_id: '',
      slip_no: '',
      vehicle_number: '',
      loading: true,
      limit: 20,
      offset: 1,
      count: 0,
    };

    this.limitInput = React.createRef();
  }

  createInvoice = () => {};

  componentDidMount() {
    this.getCreditSlips();
  }

  getCreditSlips = () => {
    services
      .getCreditSlips(this.state)
      .then((response) => {
        this.setState({
          slipList: response.data.data.results,
          count: response.data.data.count,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  sortByDate = (a, b) => {
    const data = this.state.slipList;
  };

  handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === 'start_date' && dayjs(value).isAfter(this.state.end_date)) {
      this.setState({ [name]: value, end_date: value });
    } else if (
      name === 'end_date' &&
      dayjs(value).isBefore(this.state.start_date)
    ) {
      this.setState({ [name]: value, start_date: value });
    } else {
      this.setState({ [name]: value });
    }
  };
  handleShiftChange = (e) => {
    this.setState({ shift_id: e.value });
  };

  handlePagination = (e) => {
    this.setState({ offset: e, loading: true }, function () {
      this.getCreditSlips();
    });
  };
  handleStaffChange = (e) => {
    this.setState({ staff_id: e.value });
  };

  handleBillChange = (e) => {
    this.setState({ slip_no: e.target.value });
  };

  handleProductChange = (e) => {
    this.setState({ product_id: e?.value || '' });
  };

  handleCustomerChange = (e) => {
    this.setState({ credit_customer_id: e?.value });
  };

  handleCategoryChange = (e) => {
    this.setState({ credit_customer_id: e });
  };

  handleQuickSearch = (e) => {
    e.preventDefault();
    if (
      this.limitInput.current.value === '' ||
      this.limitInput.current.value === '0'
    ) {
      return;
    }
    this.setState(
      { limit: this.limitInput.current.value, offset: 1 },
      function () {
        this.getCreditSlips();
      },
    );
  };

  editItem = (selectedId) => {
    this.setState({ selectedId: selectedId, showModal: true });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  resetFilter = () => {
    this.limitInput.current.value = 20;
    this.setState(
      {
        staff_id: '',
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        product_id: '',
        credit_customer_id: '',
        shift_id: '',
        cashier_duty_id: '',
        loading: true,
        slip_no: '',
        offset: 1,
        limit: 20,
      },
      function () {
        this.getCreditSlips();
      },
    );
  };

  confirmDelete = (item) => {
    confirmAlert({
      title: 'Confirm slip deletion',
      message: 'Are you sure',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.deleteItem(item),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  deleteItem = (item) => {
    const headers = authHeader(1);
    axios
      .delete(
        `${process.env.API_URL}/credit-customer/bunk/credit-slip/?slip_id=${item.uuid}`,
        {
          headers,
        },
      )
      .then(() => {
        toast.success('Slip deleted successfully', {
          position: 'bottom-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
        this.getCreditSlips();
        this.props.onDataChange();
      });
  };
  submitForm = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, function () {
      this.getCreditSlips();
    });
  };

  render() {
    const { slipList } = this.state;

    return (
      <section
        className={`widget full-width list-table ${this.props.cod ? 'inverted' : ''}`}
      >
        <header>
          <h3>Slips List</h3>
        </header>
        <main>
          {!this.props.cod && (
            <div className="table-filters">
              <div className="filter-wrapper">
                <div className="filter-group with-icon">
                  <label>
                    Results to display - (Total: {this.state.count})
                  </label>
                  <form onSubmit={this.handleQuickSearch}>
                    <input type="text" name="limit" ref={this.limitInput} />
                    <button
                      type="submit"
                      className="search-icon"
                      onClick={this.handleQuickSearch}
                    />
                  </form>
                </div>
                <div className="filter-group with-icon">
                  <label>Slip number:</label>
                  <form onSubmit={this.handleQuickSearch}>
                    <input
                      type="text"
                      value={this.state.slip_no}
                      onChange={this.handleBillChange}
                    />
                    <button
                      type="submit"
                      className="search-icon"
                      onClick={this.handleQuickSearch}
                    />
                  </form>
                </div>
                <div className="filter-group">
                  <label>From date:</label>
                  <input
                    className="cstm-date-input"
                    type="date"
                    value={this.state.start_date}
                    name="start_date"
                    onChange={this.handleDateChange}
                  />
                </div>
                <div className="filter-group">
                  <label>To date:</label>
                  <input
                    className="cstm-date-input"
                    type="date"
                    value={this.state.end_date}
                    min={this.state.start_date}
                    onChange={this.handleDateChange}
                    name="end_date"
                  />
                </div>
                <div className="filter-group">
                  <label>Staff:</label>
                  <StaffList
                    value={this.state.staff_id}
                    onChange={this.handleStaffChange}
                    staffType={['Cashiers', 'Managers', 'Dealer']}
                  />
                </div>
                <div className="filter-group">
                  <label>Shift:</label>
                  <ShiftsList
                    value={this.state.shift_id}
                    onChange={this.handleShiftChange}
                  />
                </div>
                <div className="filter-group">
                  <label>Product:</label>
                  <ProductList
                    onProductChange={this.handleProductChange}
                    value={this.state.product_id}
                    options={this.props.products}
                  />
                </div>
                <div className="filter-group">
                  <label>Customer:</label>
                  <CustomerList
                    onCustomerChange={this.handleCustomerChange}
                    value={this.state.credit_customer_id}
                    options={this.props.customers}
                  />
                </div>

                <div className="filter-group reset-filter">
                  <button onClick={this.resetFilter}>Reset filters</button>
                </div>
                <div className="form-actions">
                  <button
                    className="submit"
                    type="submit"
                    onClick={this.submitForm}
                  >
                    Apply filter
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="table-wrapper">
            <div className="mini-summary">
              <ul>
                <li>
                  <span>Total amount: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      slipList.reduce(
                        (a, b) =>
                          a +
                          (b['after_discount'] +
                            b['discount'] -
                            b['cash_given'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span>Total discount: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      slipList.reduce((a, b) => a + (b['discount'] || 0), 0) ||
                        0,
                    )}
                  </span>
                </li>
                <li>
                  <span>Total amount(Excl Tax): </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      slipList.reduce(
                        (a, b) =>
                          a + (b['after_discount'] - b['cash_given'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span>Total Cash given: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      slipList.reduce(
                        (a, b) => a + (b['cash_given'] || 0),
                        0,
                      ) || 0,
                    )}
                  </span>
                </li>
                <li>
                  <span>Total amount (Inc tax): </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                    }).format(
                      slipList.reduce((a, b) => a + (b['after_tax'] || 0), 0) ||
                        0,
                    )}
                  </span>
                </li>
              </ul>
            </div>
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <>
                    <TableGrid
                      col={col}
                      row={slipList}
                      offset={this.state.offset}
                      count={this.state.count}
                      limit={this.state.limit}
                      handlePagination={this.handlePagination}
                      onEdit={this.props.onEdit}
                      onDelete={this.confirmDelete}
                      invoice="credit"
                      enabledActions={enabledActions}
                      exportOptions={{
                        fileName: `Credit Sales - ${this.state.start_date} to ${this.state.end_date}`,
                        reportName: 'Credit Sales Report',
                        reportDate: `Date - ${dayjs(
                          this.state.start_date,
                        ).format(
                          'D MMM YY',
                        )} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
                        reportSales: `Total amount -  ${
                          slipList.reduce(
                            (a, b) =>
                              a +
                              (b['after_discount'] +
                                b['discount'] -
                                b['cash_given'] || 0),
                            0,
                          ) ||
                          (0).toFixed(2) ||
                          0
                        }`,
                        reportTesting: `Total discount -  ${
                          slipList
                            .reduce((a, b) => a + (b['discount'] || 0), 0)
                            .toFixed(2) || 0
                        }`,
                        reportBowser: `Total amount(Excl Tax) -  ${
                          slipList.reduce(
                            (a, b) =>
                              a + (b['after_discount'] - b['cash_given'] || 0),
                            0,
                          ) ||
                          (0).toFixed(2) ||
                          0
                        }`,
                        reportQuantity: `Total Cash given -  ${
                          slipList
                            .reduce((a, b) => a + (b['cash_given'] || 0), 0)
                            .toFixed(2) || 0
                        }`,
                        reportCustomerName: '',
                        reportTotal: `Total amount (Inc tax) -  ${
                          slipList
                            .reduce((a, b) => a + (b['after_tax'] || 0), 0)
                            .toFixed(2) || 0
                        }`,
                      }}
                    />
                  </>
                );
              }
            })()}
          </div>
        </main>
      </section>
    );
  }
}
